import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { default as fragments } from '../../fragments'

import { SvgIcon } from '../'

export class WorkflowButton extends React.Component {
  static propTypes = {
    preText: PropTypes.string.isRequired,
    postText: PropTypes.string.isRequired,
    mutationInputObj: PropTypes.object.isRequired,
    submit: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      mutationRequested: props.requested || false,  // 'requested' can be passed in by button wrapper
      mutationCompleted: false,
      mutationFailed: false
    }

    this.handleClick = this.handleClick.bind(this)
    this.runMutationQuery = this.runMutationQuery.bind(this)
  }

  handleClick(e) {
    if (this.props.onClick) {
      this.props.onClick(e)
    }

    this.setState({
      mutationRequested: true
    })

    this.runMutationQuery()
  }

  runMutationQuery() {
    this.props.submit(this.props.mutationInputObj)
    .then(({ data }) => {
      this.setState({
        mutationCompleted: true,
        mutationRequested: false
      })
    })
    .catch((error) => {
      console.log('there was an error performing the query', error)
      this.setState({
        mutationFailed: true,
        mutationRequested: false
      })
    });
  }

  render() {
    if (this.state.mutationRequested) {
      return (
        <button
          className='slds-button slds-button_brand'
          aria-live='assertive'
          disabled >
          <span>
            <SvgIcon
              variant='utility'
              symbol='task'
              className='slds-button__icon_stateful slds-button__icon_left'
            />
            {this.props.postText}
          </span>
        </button>
      )
    } else if (this.state.mutationCompleted){
      return (
        <button
          className='slds-button slds-button_brand'
          aria-live='assertive'
          disabled >
          <span>
            <SvgIcon
              variant='utility'
              symbol='success'
              className='slds-button__icon_stateful slds-button__icon_left'
            />
            {this.props.preText}
          </span>
        </button>
      )
    } else if (this.state.mutationFailed){
      return (
        <button
          className='slds-button slds-button_brand'
          aria-live='assertive'
          disabled >
          <span>
            <SvgIcon
              variant='utility'
              symbol='warning'
              className='slds-button__icon_stateful slds-button__icon_left'
            />
            {this.props.preText}
          </span>
        </button>
      )
    } else {
      return (
        <button
          className='slds-button slds-button_brand'
          onClick={this.handleClick}
          aria-live='assertive' >
          <span>
            <SvgIcon
              variant='utility'
              symbol='work_order_type'
              className='slds-button__icon_stateful slds-button__icon_left'
            />
            {this.props.preText}
          </span>
        </button>
      )
    }
  }
}

const WorkflowQuery = gql`
  mutation updateWorkflowRequest($input: WorkflowRequestMutationInput!) {
    workflowrequestMutate(input: $input) {
      workflowrequest {
        ...WorkflowRequest
      }
    }
  }
  ${fragments.workflowRequest}
`

const withData = graphql(WorkflowQuery, {
  props: ({ mutate }) => ({
    submit: (input) => mutate({ variables: { input } })
  })
})

export default withData(WorkflowButton)



// WEBPACK FOOTER //
// ./src/components/workflow-button/index.js